import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_SET_SITE_FOOTER_LINKS_PAGES_CONTENT,

  ACTION_DELETE_PAGE_CONTENT__REQUEST,
  ACTION_DELETE_PAGE_CONTENT__SUCCESS,
  ACTION_DELETE_PAGE_CONTENT__FAIL,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_SET_SITE_FOOTER_LINKS_PAGES_CONTENT:
      return action.payload.siteFooterLinksPagesContent;

    default:
      return state;
  }
};

const isBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_PAGE_CONTENT__REQUEST:
      return { ...state, [action.payload.pageContentId]: true };

    case ACTION_DELETE_PAGE_CONTENT__SUCCESS:
    case ACTION_DELETE_PAGE_CONTENT__FAIL:
      return _omit(state, action.payload.pageContentId);

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  isBeingDeleted,
});
